module.exports = __webpack_public_path__ + "img/MPP logo FINAL[81] 1.f471ce73.svg";